import React from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { TAB_VARIANT } from './constants.js';
import { TabPanelWrapper } from './styledComponents.js';
import useTheme from '../../hooks/useTheme.js';

var TabPanel = function TabPanel(_ref) {
  var id = _ref.id,
      children = _ref.children,
      customStyle = _ref.customStyle,
      variant = _ref.variant;
  var theme = useTheme();

  var _safeCustomStyle = safeCustomStyle(customStyle),
      tabPanelStyle = _safeCustomStyle.tabPanelStyle;

  return /*#__PURE__*/React.createElement(TabPanelWrapper, {
    id: "tabpanel-".concat(id),
    role: "tabpanel",
    "aria-labelledby": id,
    tabIndex: "0",
    tabPanelStyle: tabPanelStyle,
    theme: theme,
    variant: variant
  }, children);
};

process.env.NODE_ENV !== "production" ? TabPanel.propTypes = {
  /* corresponding tab id; this is provided by the Tabs component */
  id: PropTypes.string,

  /** content to be displayed for a tab */
  children: PropTypes.node,

  /** Style overrides */
  customStyle: PropTypes.shape({
    tabPanelStyle: PropTypes.object
  }),

  /** Type of Tabs to use */
  variant: PropTypes.oneOf([TAB_VARIANT.DEFAULT, TAB_VARIANT.BOX, TAB_VARIANT.BOX_LINE_TOP, TAB_VARIANT.GREY])
} : void 0;
TabPanel.defaultProps = {
  id: '',
  children: '',
  customStyle: {
    tabPanelStyle: {}
  },
  variant: TAB_VARIANT.DEFAULT
};
process.env.NODE_ENV !== "production" ? TabPanel.displayName = 'TabPanel' : void 0;
var TabPanel$1 = TabPanel;

export { TabPanel$1 as default };
